var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUserSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9137_2050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7046 20.8096C16.2854 20.8096 20.8096 16.2854 20.8096 10.7046C20.8096 5.12377 16.2854 0.599609 10.7046 0.599609C5.12377 0.599609 0.599609 5.12377 0.599609 10.7046C0.599609 16.2854 5.12377 20.8096 10.7046 20.8096Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4123 16.4287C17.5165 15.2293 16.3533 14.2555 15.0152 13.5845C13.6771 12.9136 12.2009 12.5639 10.704 12.5635C9.20702 12.563 7.73061 12.9117 6.39206 13.5818C5.05351 14.252 3.88972 15.2251 2.99316 16.4238C3.88516 17.6286 5.04705 18.6077 6.38568 19.2825C7.72432 19.9573 9.20244 20.309 10.7015 20.3095C12.2006 20.3099 13.679 19.9591 15.018 19.2852C16.3571 18.6112 17.5196 17.6329 18.4123 16.4287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7044 11.3238C12.7578 11.3238 14.4225 9.65919 14.4225 7.60576C14.4225 5.55233 12.7578 3.8877 10.7044 3.8877C8.65096 3.8877 6.98633 5.55233 6.98633 7.60576C6.98633 9.65919 8.65096 11.3238 10.7044 11.3238Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9137_2050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserSidebar);
export default __webpack_public_path__ + "static/media/ic-user-sidebar.f8319bfe483195b74438903356753b03.svg";
export { ForwardRef as ReactComponent };